module.exports = __webpack_public_path__ + "media/images/responsive/logo/service/logo_harei-84c3bc9b7bfba3ca44a727da11259b46.svg";